import React from "react";
import GlobalContextProvider from "./src/context/context";
import { GeoProvider } from "./src/context/GeoContext";
import { isTrialOnly, getBootstrappedCC } from "@utils/geo";
import { getTargetTrialUrl, TARGET_TRIAL_URL } from "@constants/urls";

function rewriteDemoLinks() {
  const cc = getBootstrappedCC();
  if (!isTrialOnly(cc)) return;

  const anchors = document.querySelectorAll(
    "a[href*='request-demo'], a[href*='demo']"
  );
  anchors.forEach((a) => {
    if (a.href.startsWith(TARGET_TRIAL_URL)) return;
    const email = (document.cookie.match(/(?:^|;)\\s*emailForm=([^;]*)/) ||
      [])[1];
    a.href = getTargetTrialUrl(email);
    a.id = "start-free-trial-cta";
    a.textContent = "Try for free";
    a.addEventListener(
      "click",
      () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "clicked_on_free_trial_cta",
          cta_text: "Try for free",
          cta_href: a.href,
          page_path: window.location.pathname,
          source: "nav_cta",
        });
      },
      { once: true }
    );
  });
}

export const onInitialClientRender = () => {
  // run once on the very first load
  setTimeout(rewriteDemoLinks, 0);

  // run again when geo arrives
  document.addEventListener("df:cc", rewriteDemoLinks, { once: true });
};

export const onRouteUpdate = () => {
  setTimeout(rewriteDemoLinks, 50);
};

export const wrapRootElement = ({ element }) => (
  <GeoProvider>
    <GlobalContextProvider>{element}</GlobalContextProvider>
  </GeoProvider>
);

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.hash === "") {
    setTimeout(() => window.scrollTo(0, 0), 10);
    return false;
  }
};
